import CardDeal from './CardDeal'

export default CardDeal
